export default __webpack_public_path__ + "static/privacy-illustration-light-ce5dda6fad844c8b592c8713b7c517bc.svg";